<!-- For Desktop Screens  -->
<app-loading *ngIf="isLoading$ | async" title="step groups"></app-loading>

<ng-container *ngIf="!isMobile">
  <div class="main-wrapper">
    <div class="left-storage-nav">
      <h1 i18n="@@storage" class="mb-4" style="font-size: xx-large">
        My Subscription plans
      </h1>
      <div class="left-card-ul-wrapper">

          <ul class="card-ul" aria-roledescription="button">
          <li
            [class.activee]="activeIndex === -1"
            (click)="
              activePlan(-1);
              updatePlanDevices(true);
              updateSwitch(true);
              clickForMobile();
              this.addNewPlanButtonClicked.emit();
            "
          >
            <span class="add-new-plan" aria-roledescription="button">
              <span>
                <img src="assets/images/plus_1828925.png" alt="" />
              </span>
              <p class="btn-add-new-plan" i18n="@@addNewPlanWeb">Add a new plan</p>
            </span>
          </li>
          <li
            *ngFor="let data of planList; let i = index"
            [class.activee]="activeIndex === i + 1"
            (click)="activePlan(i + 1)"
          >
            <p class="li-heading">{{ data?.plan?.name }}</p>
            <div class="id-review">
              <p i18n="@@multiSubsciption">Subscription ID:</p>
              <span>{{
                data?.subscriptionDetails?.shopify_subscription_id
              }}</span>
            </div>
            <div class="id-review">
              <p
                i18n="@@multiRenew"
                *ngIf="
                  data?.subscriptionDetails?.next_billing_date !=
                  data?.subscriptionDetails?.unsubscription_at
                "
              >
                Renews on:
                <span>{{
                  getSubscriptionDate(data?.subscriptionDetails)
                }}</span>
              </p>

              <p
                *ngIf="
                  data?.subscriptionDetails?.next_billing_date ==
                  data?.subscriptionDetails?.unsubscription_at
                "
                class="text-bg-warning p-2 rounded-2"
              >
                <span i18n="@@serviceStopOn">Service stops on: </span>
                <span>{{
                  getSubscriptionDate(data?.subscriptionDetails)
                }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <ng-container>
      <app-devices
        *ngIf="!shopCampatibleDevices && checkPlanHaveNoDevices"
        [extistingDevices]="true"
        [shopCampatible]="!shopCampatibleDevices"
        [existingPlanToNew]="existingPlanToNew"
        [checkPlanHaveNoDevices]="false"
        [saveButtonEnableonLeftClick]="saveButtonEnableonLeftClick"
        [statusForCheckSuccess]="statusForCheckSuccess"
        [successDeviceList]="successDeviceList"
        (checkoutUrlChange)="getCheckoutUrl($event)"
        [updatecheckSuccess]="updatecheckSuccess"
        [createCheck]="createCheck"
        [deviceCheck]="deviceCheck"
        [flowTriggered]="'update'"
        [planName]="getSelectedPlanName()"
      ></app-devices>

      <app-devices
        *ngIf="!shopCampatibleDevices && !checkPlanHaveNoDevices"
        [extistingDevices]="true"
        [shopCampatible]="!shopCampatibleDevices"
        [existingPlanToNew]="existingPlanToNew"
        [checkPlanHaveNoDevices]="false"
        [statusForCheckSuccess]="statusForCheckSuccess"
        [successDeviceList]="successDeviceList"
        (checkoutUrlChange)="getCheckoutUrl($event)"
        [updatecheckSuccess]="updatecheckSuccess"
        [createCheck]="createCheck"
        [deviceCheck]="deviceCheck"
        [flowTriggered]="'create'"
        [planName]="getSelectedPlanName()"
      ></app-devices>
    </ng-container>
  </div>
</ng-container>

<!-- For Mobile Screens  -->

<ng-container *ngIf="isMobile">
  <div class="main-wrapper">
    <ng-container
      *ngIf="leftMenuForMobile && !existingPlanToNewForMobile && !mobielCheck"
    >
      <div class="left-storage-nav">
        <h1 i18n="@@storage" class="mb-4" style="font-size: x-large">
          My Subscription plans
        </h1>

          <div *ngIf="planList.length === 0" class="alert alert-info">
              <p class="fw-bold">You do not have any cloud plans yet.</p>
              <p>Start by adding new plan below:</p>
          </div>
        <ul class="card-ul">
          <li
            [class.activee]="activeIndex === -1"
            (click)="
              activePlan(-1); updatePlanDevices(true); updateSwitch(true); this.addNewPlanButtonClicked.emit();
            "
          >
            <span class="add-new-plan">
              <span>
                <img
                  src="assets/images/plus_1828925.png"
                  alt="Add"
                  aria-hidden="true"
                />
              </span>
              <p class="btn-add-new-plan" i18n="@@addNewPlanWeb">Add a new plan</p>
            </span>
          </li>
          <li
            *ngFor="let data of planList; let i = index"
            [class.activee]="activeIndex === i + 1"
            (click)="activePlan(i + 1); onMObileView()"
          >
            <p class="li-heading">{{ data?.plan?.name }}</p>
            <div class="id-review">
              <p i18n="@@multiSubsciption">Subscription ID:</p>
              <span>{{
                data?.subscriptionDetails?.shopify_subscription_id
              }}</span>
            </div>
            <div class="id-review">
              <p
                i18n="@@multiRenew"
                *ngIf="
                  data?.subscriptionDetails?.next_billing_date !=
                  data?.subscriptionDetails?.unsubscription_at
                "
              >
                Renews on:
                <span>{{
                  getSubscriptionDate(data?.subscriptionDetails)
                }}</span>
              </p>

              <p
                class="text-bg-warning p-2 rounded-2"
                *ngIf="
                  data?.subscriptionDetails?.next_billing_date ==
                  data?.subscriptionDetails?.unsubscription_at
                "
              >
                <span i18n="@@serviceStopOn">Service stops on: </span>
                <span>{{
                  getSubscriptionDate(data?.subscriptionDetails)
                }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </ng-container>

    <ng-container
      *ngIf="!leftMenuForMobile || existingPlanToNewForMobile || mobielCheck"
    >
      <div class="loading-container" *ngIf="deviceLoader">
        <img
          src="./assets/images/loading.gif"
          alt="loading..."
          class="loading-icon"
        />
      </div>

      <app-devices
        *ngIf="!shopCampatibleDevices && checkPlanHaveNoDevices"
        [extistingDevices]="true"
        [shopCampatible]="!shopCampatibleDevices"
        [existingPlanToNew]="existingPlanToNew"
        [checkPlanHaveNoDevices]="false"
        [saveButtonEnableonLeftClick]="saveButtonEnableonLeftClick"
        [statusForCheckSuccess]="statusForCheckSuccess"
        [successDeviceList]="successDeviceList"
        (checkoutUrlChange)="getCheckoutUrl($event)"
        [updatecheckSuccess]="updatecheckSuccess"
        (goBackChange)="backListner($event)"
        [createCheck]="createCheck"
        [flowTriggered]="'update'"
      ></app-devices>

      <app-devices
        *ngIf="!shopCampatibleDevices && !checkPlanHaveNoDevices"
        [extistingDevices]="true"
        [shopCampatible]="!shopCampatibleDevices"
        [existingPlanToNew]="existingPlanToNew"
        [checkPlanHaveNoDevices]="false"
        [statusForCheckSuccess]="statusForCheckSuccess"
        [successDeviceList]="successDeviceList"
        (checkoutUrlChange)="getCheckoutUrl($event)"
        [updatecheckSuccess]="updatecheckSuccess"
        (goBackChange)="backListner($event)"
        [createCheck]="createCheck"
        [flowTriggered]="'create'"
      ></app-devices>
    </ng-container>
  </div>
</ng-container>
